var allPanels = $('.accordion > dd').hide();
$('.accordion > dt > a').click(function () {
    if(!$(this).parent().next().is(':visible')) {
        allPanels.slideUp();
        $('.answer-visible').removeClass('answer-visible');
        $(this).closest('.accordion').find('a').removeClass('visible');
        $(this).addClass('visible');
        $('.accordion small.right').html('&#9668;');
        $(this).find('small.right').html('&#9660;');
        $(this).parent().next().addClass('answer-visible').slideDown();
    } else {
        $(this).parent().next().slideUp();
        $(this).closest('.accordion').find('a').removeClass('visible');
    }

    return false;
});